"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.boardTypeList = exports.DEFALUT_PATH = exports.BOARD_TYPE_KR = exports.BOARD_TYPE = void 0;
exports.BOARD_TYPE = {
    HOME: 'Home',
    LINK: 'Link',
    FOLDER: 'Folder',
    PHOTOCARD: 'PhotoCard',
    GALLERY: 'Gallery',
    TIMELINE: 'Timeline',
    POSTING: 'Posting',
    COUPLE: 'Couple',
    GUESTBOOK: 'GuestBook',
    CALENDAR: 'Calendar',
    STICKERBOARD: 'StickerBoard',
    TRPG: 'Trpg',
    CHALLENGE: 'Challenge',
    MEMO: 'Memo',
    WORLD: 'world',
    HISTORY: 'history',
    STORE: 'store',
    CALCULATE: 'calculate',
    EXPLORATION: 'Exploration',
    RAID: 'Raid',
    WORLDMAP: 'Worldmap',
    GAMBLING: 'Gambling',
    FORM: 'Form',
    THREADS: 'Threads',
    PET: 'Pet',
    QUEST: 'Quest',
    INTERACTIVE_STORY: 'InteractiveStory',
    BETTING: 'Betting',
};
exports.BOARD_TYPE_KR = {
    HOME: '기본 홈',
    PHOTOCARD: '포토카드형',
    GALLERY: '갤러리형',
    TIMELINE: '타임라인형',
    POSTING: '포스팅형',
    COUPLE: '커플형',
    GUESTBOOK: '방명록형',
    CALENDAR: '캘린더형',
    STICKERBOARD: '스티커보드형',
    TRPG: 'TRPG형',
    INTERACTIVE_STORY: '인터랙티브 스토리형',
    LINK: '커스텀메뉴형',
    MEMO: '메모형',
    FOLDER: '📁 폴더',
    WORLD: '세계관형',
    HISTORY: '연표형',
    STORE: '상점형',
    CALCULATE: '정산형',
    EXPLORATION: '탐험조사형',
    RAID: '레이드형',
    WORLDMAP: '월드맵형',
    GAMBLING: '도박형',
    FORM: '폼형',
    THREADS: '스레드형',
    PET: '펫형',
    QUEST: '퀘스트형',
    BETTING: '베팅형',
};
exports.DEFALUT_PATH = {
    HOME: 'home',
    PHOTOCARD: 'photocard',
    GALLERY: 'gallery',
    TIMELINE: 'timeline',
    POSTING: 'posting',
    COUPLE: 'couple',
    GUESTBOOK: 'guestbook',
    CALENDAR: 'calendar',
    STICKERBOARD: 'stickerBoard',
    TRPG: 'trpg',
    CHATROOM: 'chatRoom',
    CHALLENGE: 'challenge',
    MEMO: 'memo',
    WORLD: 'world',
    HISTORY: 'history',
    STORE: 'store',
    CALCULATE: 'calculate',
    EXPLORATION: 'exploration',
    RAID: 'raid',
    INTERACTIVE_STORY: 'interactiveStory',
    WORLDMAP: 'worldmap',
    GAMBLING: 'gambling',
    FORM: 'form',
    THREADS: 'threads',
    PET: 'pet',
    QUEST: 'quest',
    BETTING: 'betting',
};
exports.boardTypeList = Object.keys(exports.BOARD_TYPE).map(function (key) {
    return {
        key: key,
        value: exports.BOARD_TYPE_KR[key],
    };
});
//# sourceMappingURL=boardType.js.map